import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { DataSources as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-datasources.sass');

export class DataSources extends WidgetBase {
    public static _name: string = 'Data Sources';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-datasources';
    public static icon: string = 'random';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-datasources'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(DataSources);
